var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9399 4.46015L8.43994 0.0851487C8.34435 0.029384 8.23567 0 8.125 0C8.01433 0 7.90565 0.029384 7.81006 0.0851487L0.310062 4.46015C0.215708 4.51519 0.137428 4.59401 0.0830249 4.68873C0.0286219 4.78346 -4.15066e-06 4.89079 4.51406e-10 5.00002V13.75C-4.15066e-06 13.8593 0.0286219 13.9666 0.0830249 14.0613C0.137428 14.156 0.215708 14.2349 0.310062 14.2899L7.81006 18.6649C7.90565 18.7207 8.01433 18.75 8.125 18.75C8.23567 18.75 8.34435 18.7207 8.43994 18.6649L15.9399 14.2899C16.0343 14.2349 16.1126 14.156 16.167 14.0613C16.2214 13.9666 16.25 13.8593 16.25 13.75V5.00002C16.25 4.89079 16.2214 4.78346 16.167 4.68873C16.1126 4.59401 16.0343 4.51519 15.9399 4.46015ZM8.125 1.34859L14.3848 5.00002L8.125 8.65146L1.86525 5.00002L8.125 1.34859ZM1.25 6.08827L7.5 9.7339V17.0368L1.25 13.3911V6.08827ZM8.75 17.0368V9.7339L15 6.08827V13.3911L8.75 17.0368Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCube);
export default __webpack_public_path__ + "static/media/ic-cube.50dfd1cb735f55df55618d4dff305382.svg";
export { ForwardRef as ReactComponent };